export const admin = {
    title: 'FSD Admin',
    header: {
        title: 'Admin Panel',
        toggleMenu: 'Toggle menu',
    },
    nav: {
        dashboard: 'Dashboard',
        newDrones: 'New Drones',
        usedDrones: 'Used Drones',
        buffalo: 'Buffalo Line',
        powerCitros: 'Power Citros',
        parts: 'Parts & Accessories',
    },
    dashboard: {
        title: 'Dashboard',
        description: 'Welcome to Fronteira Sul Drones admin panel',
        stats: {
            totalNewDrones: 'New Drones',
            totalUsedDrones: 'Used Drones',
            totalBuffalo: 'Buffalo Line',
            totalPowerCitros: 'Power Citros',
            totalParts: 'Parts & Accessories',
        },
    },
    newDrones: {
        title: 'New Drones',
        description: 'Manage new drones in the system',
        empty: 'No new drones registered. Click "Add Drone" to get started.',
        addButton: 'Add Drone',
    },
    usedDrones: {
        title: 'Used Drones',
        description: 'Manage used drones in the system',
        empty: 'No used drones registered. Click "Add Drone" to get started.',
        addButton: 'Add Drone',
    },
    buffalo: {
        title: 'Buffalo Line',
        description: 'Manage Buffalo motors and attached equipment in the system',
        empty: 'No Buffalo Line item registered. Click "Add" to get started.',
        addButton: 'Add Buffalo Item',
    },
    powerCitros: {
        title: 'Power Citros',
        description: 'Manage Power Citros products — citrus-based ultra degreaser cleaner',
        empty: 'No Power Citros products registered. Click "Add" to get started.',
        addButton: 'Add Power Citros Product',
    },
    parts: {
        title: 'Parts & Accessories',
        description: 'Manage parts and accessories in the system',
        empty: 'No parts or accessories registered. Click "Add" to get started.',
        addButton: 'Add Part/Accessory',
    },
    theme: {
        toggle: 'Toggle theme',
        light: 'Light theme',
        dark: 'Dark theme',
        system: 'System theme',
    },
};
//# sourceMappingURL=admin.js.map